import { createConsumer, type Consumer } from "@rails/actioncable"

let consumer: Consumer | null = null

export function getConsumer(): Consumer {
  if (!consumer) {
    // Uses the default /cable path
    consumer = createConsumer()
  }
  return consumer
}

export function disconnectConsumer(): void {
  if (consumer) {
    consumer.disconnect()
    consumer = null
  }
}
